import React from "react";
import { Box } from "@mui/material";
import BottomNav from "./BottomNav";

export const NAV_HEIGHT = 56;

// Wraps the four footer-tab pages (Home, Live/Completed/Online Orders) with
// the persistent bottom nav; Cart/OrderConfirmation/Login render standalone.
export default function MainLayout({ children }) {
  return (
    <Box sx={{ pb: `${NAV_HEIGHT}px` }}>
      {children}
      <BottomNav />
    </Box>
  );
}
